module.exports = __webpack_public_path__ + "static/media/banner-ban-moi.4da6e0fb.jpg";